import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging (FCM) and get a reference to the service
let messaging: any = null;

// Check if messaging is supported (not supported in all browsers/environments)
const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(firebaseApp);
      console.log('Firebase messaging initialized successfully');
    } else {
      console.warn('Firebase messaging is not supported in this environment');
    }
  } catch (error) {
    console.error('Error initializing Firebase messaging:', error);
  }
  return messaging;
};

export { firebaseApp, messaging, initializeMessaging };
export const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;